// Build-Stand des laufenden Backends + Ladezeit dieses Seitenaufrufs.
//
// Zwei Konsumenten mit unterschiedlicher Ausfuehrlichkeit: der
// Seiten-Fuss (Telefon, ausgeschrieben) und die Statusleiste der Shell
// (Schreibtisch, kompakt). Die Werte selbst sind dieselben -- deshalb
// liegen sie hier und nicht zweimal in den Komponenten.
//
// Beide Werte aendern sich nach dem Boot nicht mehr: die Version wird
// einmal geholt, die Ladezeit einmal gemessen. Kein Polling.

import { fetchVersion } from "./version-fetch";

export interface VersionInfo {
  version?: string;
  commit?: string;
  build_time?: string;
  go_version?: string;
}

/** Aufteilung der Ladezeit aus der Navigation-Timing-API. Bewusst die
 *  ECHTEN Messwerte des Browsers statt einer eigenen Stoppuhr -- sie
 *  zeigen, WO die Zeit hinging: Warten aufs Backend, Uebertragung, oder
 *  Parsen und Aufbau im Browser. Gilt nur fuer den Erstaufruf; der
 *  Router laedt danach nicht neu. */
export interface LadeZeit {
  total: number;
  server: number;
  transfer: number;
  build: number;
}

let version = $state<VersionInfo | null>(null);
let ladezeit = $state<LadeZeit | null>(null);
let gestartet = false;

function lies(): LadeZeit | null {
  const e = performance.getEntriesByType("navigation")[0] as
    | PerformanceNavigationTiming
    | undefined;
  if (!e) return null;
  // loadEventEnd ist 0, solange das load-Ereignis nicht durch ist.
  const end = e.loadEventEnd || performance.now();
  return {
    total: Math.round(end - e.startTime),
    server: Math.round(e.responseStart - e.requestStart),
    transfer: Math.round(e.responseEnd - e.responseStart),
    build: Math.round(end - e.responseEnd),
  };
}

/** startVersionInfo holt die Version und misst die Ladezeit. Idempotent. */
export function startVersionInfo(): void {
  if (gestartet) return;
  gestartet = true;

  // Erst NACH dem load-Ereignis messen, sonst fehlt die halbe Wahrheit.
  if (document.readyState === "complete") ladezeit = lies();
  else window.addEventListener("load", () => (ladezeit = lies()), { once: true });

  // Geteilte Leitung (version-fetch): die Update-Erkennung in pwa.svelte
  // fragt dieselbe Adresse und benutzt denselben Abruf mit.
  void fetchVersion().then((v) => {
    // null = offline / nicht eingeloggt -> die Anzeige bleibt schlicht
    if (v) version = v;
  });
}

export function getVersionInfo(): VersionInfo | null {
  return version;
}
export function getLadezeit(): LadeZeit | null {
  return ladezeit;
}

/** ms unter einer Sekunde, darueber Sekunden mit einer Nachkommastelle. */
export function ms(n: number): string {
  return n < 1000
    ? `${n} ms`
    : `${(n / 1000).toLocaleString("de-DE", { maximumFractionDigits: 1 })} s`;
}

export function buildZeit(iso?: string): string {
  if (!iso || iso === "unknown") return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
